
export function getSomeName(feedback, includeUsername = false) {
    const username = ko.unwrap(feedback.authorUsername);
    const authorName = (ko.unwrap(feedback.authorName) || '').trim();

    if (authorName) {
        if (includeUsername) {
            return `${authorName} (${username})`;
        } else {
            return `${authorName}`;
        }
    }

    const email = (ko.unwrap(feedback.authorEmail) || '').trim();

    if (email) {
        if (includeUsername) {
            return `${email} (${username})`;
        } else {
            return `${email}`;
        }
    }

    return username;
}